import React from 'react'

type Props = {
  width?: number
  height?: number
}

const CareerCardPlaceholder: React.FC<Props> = ({
  width = 100,
  height = 148,
}) => (
  <div
    aria-hidden="true"
    style={{ width: `${width}px`, height: `${height}px` }}
    className="shrink-0 relative"
  >
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      className="block"
    >
      <rect
        x={1}
        y={1}
        width={width - 2}
        height={height - 2}
        rx={4}
        ry={4}
        fill="#E8E8E8"
        fillOpacity={0.15}
        stroke="#E8E8E8"
        strokeWidth={2}
        strokeDasharray="6 6"
      />
    </svg>
    <div
      className="absolute inset-0 flex flex-col"
      style={{
        paddingTop: 14,
        paddingRight: 6,
        paddingBottom: 32,
        paddingLeft: 6,
        gap: 6,
      }}
    />
  </div>
)

export default CareerCardPlaceholder
